import * as d3 from "d3";
import styled from "styled-components";

export function getItemsUpdate({
  items,
  now,
  fields,
  timeOffset,
  timeFrame,
  timeWindow,
  newValue,
  window,
  valueKeys,
}) {
  let itemsUpdate = [];
  let newWindow = window;
  if (timeWindow === 2) {
    if (newWindow === 0 || items.length === 0) {
      itemsUpdate = createNewItems(now, fields, valueKeys);
      newWindow = 1;
    } else if (timeFrame > 1 * 60 * 1000 && newWindow === 1) {
      itemsUpdate = prepend(1, items, fields, valueKeys);
      newWindow = 2;
    } else if (timeFrame < 1 * 60 * 1000 && newWindow === 1) {
      itemsUpdate = getItemsUpdateCorrected(
        newValue,
        items,
        itemsUpdate,
        1 * 60 * 1000 + 1000
      );
    } else {
      itemsUpdate = getItemsUpdateCorrected(
        newValue,
        items,
        itemsUpdate,
        2 * 60 * 1000 + 1000
      );
    }
    return { itemsUpdate, window: newWindow };
  }
  if (timeWindow === 5) {
    if (newWindow === 0 || items.length === 0) {
      itemsUpdate = createNewItems(now, fields, valueKeys);
      newWindow = 1;
    } else if (timeFrame > 1 * 60 * 1000 && newWindow === 1) {
      itemsUpdate = prepend(1, items, fields, valueKeys);
      newWindow = 2;
    } else if (timeFrame < 1 * 60 * 1000 && newWindow === 1) {
      itemsUpdate = getItemsUpdateCorrected(
        newValue,
        items,
        itemsUpdate,
        1 * 60 * 1000 + 1000
      );
    } else if (timeFrame > 2 * 60 * 1000 && newWindow === 2) {
      itemsUpdate = prepend(1, items, fields, valueKeys);
      newWindow = 3;
    } else if (timeFrame < 2 * 60 * 1000 && newWindow === 2) {
      itemsUpdate = getItemsUpdateCorrected(
        newValue,
        items,
        itemsUpdate,
        2 * 60 * 1000 + 1000
      );
    } else if (timeFrame > 3 * 60 * 1000 && newWindow === 3) {
      itemsUpdate = prepend(2, items, fields, valueKeys);
      newWindow = 5;
    } else if (timeFrame < 3 * 60 * 1000 && newWindow === 3) {
      itemsUpdate = getItemsUpdateCorrected(
        newValue,
        items,
        itemsUpdate,
        3 * 60 * 1000 + 1000
      );
    } else {
      itemsUpdate = getItemsUpdateCorrected(
        newValue,
        items,
        itemsUpdate,
        5 * 60 * 1000 + 1000
      );
    }
    return { itemsUpdate, window: newWindow };
  }
  if (newWindow === 0 || items.length === 0) {
    itemsUpdate = createNewItems(now, fields, valueKeys);
    newWindow = 1;
  } else if (timeFrame > 1 * 60 * 1000 && newWindow === 1) {
    itemsUpdate = prepend(1, items, fields, valueKeys);
    newWindow = 2;
  } else if (timeFrame < 1 * 60 * 1000 && newWindow === 1) {
    itemsUpdate = getItemsUpdateCorrected(
      newValue,
      items,
      itemsUpdate,
      1 * 60 * 1000 + 1000
    );
  } else if (timeFrame > 2 * 60 * 1000 && newWindow === 2) {
    itemsUpdate = prepend(1, items, fields, valueKeys);
    newWindow = 3;
  } else if (timeFrame < 2 * 60 * 1000 && newWindow === 2) {
    itemsUpdate = getItemsUpdateCorrected(
      newValue,
      items,
      itemsUpdate,
      2 * 60 * 1000 + 1000
    );
  } else if (timeFrame > 3 * 60 * 1000 && newWindow === 3) {
    itemsUpdate = prepend(2, items, fields, valueKeys);
    newWindow = 5;
  } else if (timeFrame < 3 * 60 * 1000 && newWindow === 3) {
    itemsUpdate = getItemsUpdateCorrected(
      newValue,
      items,
      itemsUpdate,
      3 * 60 * 1000 + 1000
    );
  } else if (timeFrame > 5 * 60 * 1000 && newWindow === 5) {
    itemsUpdate = prepend(5, items, fields, valueKeys);
    newWindow = 10;
  } else if (timeFrame < 5 * 60 * 1000 && newWindow === 5) {
    itemsUpdate = getItemsUpdateCorrected(
      newValue,
      items,
      itemsUpdate,
      5 * 60 * 1000 + 1000
    );
  } else {
    itemsUpdate = getItemsUpdateCorrected(
      newValue,
      items,
      itemsUpdate,
      10 * 60 * 1000 + 1000
    );
  }
  return { itemsUpdate, window: newWindow };
}

function getItemsUpdateCorrected(newValue, items, itemsUpdate, diffValue) {
  const endTime = newValue?.time?.getTime();
  const startTime = items[0]?.time?.getTime();
  if (!endTime || !startTime) {
    return items;
  }
  if (endTime - startTime > diffValue) {
    let j = items.length - 1;
    let newItems = [];
    while (j >= 0 && endTime - items[j].time.getTime() <= diffValue) {
      if (endTime - items[j].time.getTime() <= diffValue) {
        newItems.unshift(items[j]);
      }
      j--;
    }
    itemsUpdate = newItems;
  } else {
    itemsUpdate = items;
  }
  return itemsUpdate;
}

function createNewItems(now, fields, valueKeys) {
  let newItems = [];
  const newValue = valueKeys.reduce((acc, key) => {
    acc[key] = 0;
    return acc;
  }, {});
  const start = now.getTime() - 1 * 60 * 1000;
  for (let i = start; i < now.getTime(); i += 1000) {
    const time = new Date(i);
    time.setMilliseconds(500);
    const newItem = { time };
    for (let field of fields) {
      newItem[field.name] = newValue;
    }
    newItems.push(newItem);
  }
  return newItems;
}

export function prepend(nMinutes, items, fields, valueKeys) {
  if (!items[0]?.time?.getTime()) {
    return [...items];
  }
  const fill = [];
  const start = items[0].time.getTime() - nMinutes * 60 * 1000;
  for (let i = start; i < items[0].time.getTime(); i += 1000) {
    const time = new Date(i);
    time.setMilliseconds(500);
    const newItem = { time: new Date(i) };
    const newValue = valueKeys.reduce((acc, key) => {
      acc[key] = 0;
      return acc;
    }, {});
    for (let field of fields) {
      newItem[field.name] = newValue;
    }
    fill.push(newItem);
  }
  return [...fill, ...items];
}

export const getHoveredTime = (mouseEvent, items, range) => {
  if (!mouseEvent || items.length === 0) {
    return null;
  }
  const { mouseXMain, rangeMain, mouseXExtra, rangeExtra } = mouseEvent;
  if (mouseXMain !== null && rangeMain) {
    const xScale = d3
      .scaleTime()
      .domain([items[0].time, items[items.length - 1].time])
      .range([0, rangeMain]);
    return xScale.invert(mouseXMain);
  }
  if (mouseXExtra !== null && rangeExtra) {
    const xScale = d3
      .scaleTime()
      .domain([items[0].time, items[items.length - 1].time])
      .range([0, rangeExtra]);
    return xScale.invert(mouseXExtra);
  }
  return null;
};

export const getMouseX = (mouseEvent, rangeMain, rangeExtra) => {
  if (!mouseEvent) {
    return null;
  }
  const { mouseXMain, mouseXExtra } = mouseEvent;
  if (mouseXMain) {
    return { mouseXMain, mouseXExtra: mouseXMain * (rangeExtra / rangeMain) };
  }
  if (mouseXExtra) {
    return { mouseXExtra, mouseXMain: mouseXExtra * (rangeMain / rangeExtra) };
  }
  return null;
};

export const getValueItems = (items, key) => {
  return items.map((item) => {
    return Object.entries(item).reduce((acc, value) => {
      const [keyItem, valueItem] = value;
      if (keyItem === "time") {
        acc[keyItem] = valueItem;
      }else if(keyItem !== "total") {
        acc[keyItem] = valueItem[key];
      } 
      return acc;
    }, {});
  });
};

export const getValueExtraItems = (items, key, type) => {
  return items.reduce(
    (accItems, item) => {
      const itemNew = Object.entries(item).reduce((acc, value) => {
        const [keyItem, valueItem] = value;
        if (keyItem === "time") {
          acc[keyItem] = valueItem;
        } else if (keyItem === "total") {
          const totalValue = valueItem ? Number(valueItem[key]) : undefined;
          acc["total"] = totalValue;
          if (totalValue > accItems.max) {
            accItems.max = totalValue;
          }
        } else {
          acc[keyItem] = valueItem[`${type}${key}`];
        }
        return acc;
      }, {});
      accItems.items.push(itemNew);
      return accItems;
    },
    { items: [], max: 0 }
  );
};

export function getTableValue(value) {
  if (value === undefined || value === "n/a" || value === null) {
    return "n/a";
  }
  return d3.format(".3f")(value);
}

export function getParsedValue(value) {
  if (value === undefined || value === "n/a") {
    return null;
  }
  return parseFloat(value);
}

export function getSumValue(value) {
  if (value === undefined || value === "n/a" || value === null) {
    return 0;
  }
  return Number(value);
}

export function getTableAvgValue(value, seconds) {
  if (value === undefined || value === "n/a" || value === null || seconds === 0) {
    return "n/a";
  }
  return d3.format(".3f")(value/seconds);
}

export const Title = styled.h4`
  font-weight: 100;
  font-size: var(--chart-title-font-size) !important;
`;

export const CursorLine = styled.div`
  position: absolute;
  width: 2px;
  z-index: 1500;
  background-color: var(--Text-Primary);
`;

export const LegendContainer = styled.div`
  > div {
    display: block;
  }
`;

export const fieldTotal = { name: "total", label: "total", color: "#ff0000" };